import 'css-chunksrc/client/scenes/costProfileEdition/styles.scss';export default {
  "costProfileEdition": "_costProfileEdition_10yqp_1",
  "main": "_main_10yqp_8",
  "history": "_history_10yqp_14",
  "label": "_label_10yqp_21",
  "footer": "_footer_10yqp_28",
  "button": "_button_10yqp_36"
};